import { useRef } from "react";
import { AllieTextProps } from "../../../components";
import { StyledAlliePopover, StyledEllipsedText } from "./EllipsedText.styles";

interface TextProps {
  triggerId: string;
  value: string;
  maxLength?: number;
  width?: number | string;
  maxWidth?: number | string;
  className?: string;
  style?: any;
  textProps?: AllieTextProps;
  tooltipEnabled?: boolean;
  triggerAction?: 'click' | 'hover';
}

interface EllipsedTextProps extends TextProps {
  ellipsis?: boolean;
};

const Text: React.FC<EllipsedTextProps> = ({
  triggerId,
  value,
  ellipsis = false,
  width,
  maxWidth,
  className,
  style,
  textProps,
  ...props
}) => (
  <div
    id={triggerId}
    className={className}
    style={style}
    {...props}
  >
    <StyledEllipsedText
      ellipsis={ellipsis}
      width={width}
      maxWidth={maxWidth}
      { ...textProps }
    >
      {value}
    </StyledEllipsedText>
  </div>
);

const MAX_TEXT_LENGTH = 29;
const DEFAULT_WIDTH = 250;

export const AllieEllipsedText = ({
  triggerId,
  value,
  maxLength,
  width = 'auto',
  maxWidth = DEFAULT_WIDTH,
  className,
  textProps = {},
  style,
  tooltipEnabled = true,
  triggerAction = "click",
}: TextProps) => {
  const tooltipRef = useRef<HTMLIonPopoverElement>(null);

  const popoverMouseEvents = {
    onmouseleave: () => {
      tooltipRef.current?.dismiss();
    },
  }

  const calcLength = maxLength || (
    !isNaN(Number(maxWidth))
      ? (Number(maxWidth) * MAX_TEXT_LENGTH / DEFAULT_WIDTH)
      : MAX_TEXT_LENGTH
  );

  return (
    <>
      <Text
        triggerId={triggerId}
        value={value}
        ellipsis={true}
        width={width}
        maxWidth={maxWidth}
        className={className}
        style={style}
        textProps={textProps}
      />
      {
        value.length > calcLength && tooltipEnabled && (
          <StyledAlliePopover
            ref={tooltipRef}
            trigger={triggerId}
            triggerAction={triggerAction}
            alignment="center"
            side="top"
            showBackdrop={false}
            content={{
              className: "ion-padding",
              children: (
                <Text
                  triggerId={triggerId}
                  value={value}
                  className={className}
                  style={style}
                  textProps={textProps}
                />
              ),
              ...popoverMouseEvents
            }}
          />
        )
      }
    </>
  );
};
